import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import WizardContext from "./internals/WizardContext";
import { Stepper } from "../stepper/Stepper";
export var WizardStepper = function (_a) {
    var _b = _a.nonLinear, nonLinear = _b === void 0 ? false : _b, steps = _a.steps, _c = _a.width, width = _c === void 0 ? "auto" : _c, _d = _a.stepHeight, stepHeight = _d === void 0 ? "48px" : _d;
    var _e = useContext(WizardContext), activeStep = _e.activeStep, completed = _e.completed;
    return (_jsx(Stepper, { activeStep: activeStep, nonLinear: nonLinear, steps: steps, width: width, stepHeight: stepHeight, completed: completed }));
};
